import { render, staticRenderFns } from "./EnrollmentReport.vue?vue&type=template&id=28f71076&scoped=true&"
import script from "./EnrollmentReport.vue?vue&type=script&lang=js&"
export * from "./EnrollmentReport.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentReport.vue?vue&type=style&index=0&id=28f71076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f71076",
  null
  
)

export default component.exports